export default __webpack_public_path__ + "static/media/logo2.be4e6d60.png";